import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Row, Col, Form } from "antd";
import { useGetCaseAkaMutation } from "../../../state/globalApi";
import { buildSummaryRequest } from "../../../state/connect-api";
import { updateCaseMaster } from "../../../state/globalStore";
import { RootState } from "../../../store";
import CaseAkaInformation from "./case-aka-information";

const CaseAka = () => {
  const [form] = Form.useForm();
  const { activeCaseNumber, caseMaster } = useSelector((state: RootState) => state.global);
  const dispatch = useDispatch();
  const [getCaseAka] = useGetCaseAkaMutation();

  useEffect(() => {
    const lookupRequest = buildSummaryRequest(activeCaseNumber);
    const fetch = async () => {
      const aka = await getCaseAka(lookupRequest).unwrap();
      dispatch(updateCaseMaster({ aka: aka }));
    };

    fetch();
  }, [activeCaseNumber, dispatch, getCaseAka]);

  return (
    <Row gutter={[16, 16]}>
      <Col xl={12} lg={12} md={24} sm={24} xs={24}>
        <CaseAkaInformation caseMaster={caseMaster} form={form} />
      </Col>
    </Row>
  );
};

export default CaseAka;
